<template>
  <div class="kyujitsuToroku">
    <el-dialog title="休日登録" :visible="kyujitsuDialogVisible" @open="getData(false)" @close="$emit('close-kyujitsu-dialog')" width="1300px" top="35px">
      <el-row id="formArea">
        <el-col :span="6">
          <span>拠点：</span>
          <el-select v-model="form.kyotenCd" @change="onKuniChange" size="medium" class="kuni">
            <el-option v-for="cd in kyotenCds" :key="cd.value" :label="cd.label" :value="cd.value"></el-option>
          </el-select>
        </el-col>
        <el-col :span="12">
          <el-button type="default" @click="onChange(-1)" size="medium" icon="el-icon-arrow-left">前年</el-button>
          <el-date-picker v-model="form.nen" type="year" @change="onChange" format="yyyy年" value-format="yyyy" :editable="false" :clearable="false" class="nen" size="medium"></el-date-picker>
          <el-button type="default" @click="onChange(1)" size="medium">翌年 <i class="el-icon-arrow-right" /></el-button>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="onSave" size="medium">保存</el-button>
          <el-button type="default" @click="onCopy" size="medium">前年コピー</el-button>
        </el-col>
      </el-row>

      <el-row id="detailArea" v-loading="loading">
        <el-col :span="8.9">
          <div class="title">■休日設定</div>
          <el-table :data="form.kyujitsuList" size="medium" :max-height="tableHeight">
            <el-table-column label="No" type="index" align="right" width="40">
            </el-table-column>
            <el-table-column label="" width="50">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" class="sakujo" @click="onDelete('kyujitsu', scope.$index, scope.row.hizuke, scope.row.kyujitsuMei)">削除</el-button>
              </template>
            </el-table-column>
            <el-table-column label="日付" width="145">
              <template slot-scope="scope">
                <el-date-picker v-model="scope.row.hizuke" value-format="yyyy-MM-dd" :clearable="false" class="hizuke"></el-date-picker>
              </template>
            </el-table-column>
            <el-table-column label="休日名" width="250">
              <template slot-scope="scope">
                <el-input v-model="scope.row.kyujitsuMei" maxlength="30"></el-input>
              </template>
            </el-table-column>
          </el-table>
          <el-button size="mini" type="success" class="tsuika" @click="onAddKyujitsu">追加</el-button>
        </el-col>
        <el-col :span="15.1">
          <div class="title">■社員総会設定</div>
          <el-table :data="form.shainSokaiList" size="medium" :max-height="tableHeight">
            <el-table-column label="No" type="index" align="right" width="40">
            </el-table-column>
            <el-table-column label="" width="50">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" class="sakujo" @click="onDelete('shainSokai', scope.$index, scope.row.hizuke, '社員総会')">削除</el-button>
              </template>
            </el-table-column>
            <el-table-column label="日付" width="145">
              <template slot-scope="scope">
                <el-date-picker v-model="scope.row.hizuke" value-format="yyyy-MM-dd" :clearable="false" class="hizuke"></el-date-picker>
              </template>
            </el-table-column>
            <el-table-column label="始業時刻" width="110">
              <template slot-scope="scope">
                <el-input v-model="scope.row.kijunShigyoJikoku" type="time" class="jikoku"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="終業時刻" width="110">
              <template slot-scope="scope">
                <el-input v-model="scope.row.kijunShugyoJikoku" type="time" class="jikoku"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="昼食時間" width="110">
              <template slot-scope="scope">
                <el-input v-model="scope.row.kijunChusyokuJikan" type="time" class="jikoku"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="休憩時間" width="110">
              <template slot-scope="scope">
                <el-input v-model="scope.row.kijunKyukeiJikan" type="time" class="jikoku"></el-input>
              </template>
            </el-table-column>
          </el-table>
          <el-button size="mini" type="success" class="tsuika" @click="onAddShainSokai">追加</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { notifySuccess, notifyError } from '../utils.js'

export default {
  name: 'KyujitsuToroku',
  props: ['kyujitsuDialogVisible'],
  data() {
    return {
      form: {
        kyotenCd: '',
        nen: '',
        kyujitsuList: [],
        shainSokaiList: []
      },
      kyotenCds: [
        {value: 'JP', label: '日本'},
        {value: 'TH', label: 'タイ'},
      ],
      tableHeight: 100,
      loading: true
    }
  },
  computed: {
  },
  created() {
    this.form.kyotenCd = 'JP';
    this.form.nen = this.$parent.$parent.getNen();
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      //this.tableHeight = window.innerHeight - 300;
      this.tableHeight = document.documentElement.clientHeight - 300;
    },
    onChange(offset) {
      if (offset == 1 || offset == -1) {
        this.form.nen = this.$moment(this.form.nen).add(offset, 'Y').format('YYYY');
      }
      this.$parent.$parent.setNen(this.form.nen);
      this.getData(false);
    },
    onKuniChange() {
      this.getData(false);
    },
    onCopy() {
      this.$confirm('前年と同じ日付で今年にコピーします。<br/>コピー後に今年の日付に修正してください。<br/>（入力済みのデータは削除されます。）', '確認', {
        confirmButtonText: 'はい',
        cancelButtonText: 'キャンセル',
        type: 'info',
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.getData(true);
      });
    },
    getData(isCopy) {
      this.loading = true;
      const nen = isCopy ? Number(this.form.nen) - 1 : this.form.nen;
      this.$axios.get(`/gwr/kyujitsu/kyujitsuList/${this.form.kyotenCd}/${nen}`)
          .then((response) => {
            const list = isCopy ? response.data.map(d => {
              const hizuke = new Date(d.hizuke);
              hizuke.setFullYear(Number(this.form.nen));
              d.hizuke = hizuke.toISOString().split('T')[0];
              return d;
            }) : response.data;
            this.form.kyujitsuList = list.filter(d => d.kyujitsuFlag).sort();
            this.form.shainSokaiList = list.filter(d => d.eigyobiFlag).sort();
            this.loading = false;
            this.handleResize();
          })
          .catch((error) => {
            notifyError(this, error, 'データ取得エラー');
          });
    },
    onSave() {
      const errorMessage = this.validate();
      if (errorMessage) {
        notifyError(this, null, '入力エラー', errorMessage);
        return;
      }
      this.loading = true;
      this.$axios.post('/gwr/kyujitsu/save', {kyotenCd: this.form.kyotenCd, nen: this.form.nen, kyujitsuList: this.form.kyujitsuList.concat(this.form.shainSokaiList)})
          .then(() => {
            notifySuccess(this, '登録完了', '休日・社員総会情報を登録しました。');
            this.getData(false);
          })
          .catch((error) => {
            notifyError(this, error, 'データ登録エラー');
          });
    },
    validate() {
      let rowNum = 0;
      for (let kyujitsu of this.form.kyujitsuList) {
        rowNum++;
        if (!kyujitsu.hizuke) {
          return `日付を入力してください。<br/>(休日設定 ${rowNum}行目)`
        } else if (!kyujitsu.hizuke.startsWith(this.form.nen)) {
          return `${this.form.nen}年の日付を入力してください。<br/>(休日設定 ${rowNum}行目)`
        }
        if (!kyujitsu.kyujitsuMei) {
          return `休日名を入力してください。<br/>(休日設定 ${rowNum}行目)`
        }
      }
      rowNum = 0;
      for (let sokai of this.form.shainSokaiList) {
        rowNum++;
        if (!sokai.hizuke) {
          return `日付を入力してください。<br/>(社員総会設定 ${rowNum}行目)`
        } else if (!sokai.hizuke.startsWith(this.form.nen)) {
          return `${this.form.nen}年の日付を入力してください。<br/>(社員総会設定 ${rowNum}行目)`
        }
        if (!sokai.kijunShigyoJikoku) {
          return `始業時刻を入力してください。<br/>(社員総会設定 ${rowNum}行目)`
        }
        if (!sokai.kijunShugyoJikoku) {
          return `終業時刻を入力してください。<br/>(社員総会設定 ${rowNum}行目)`
        }
      }
    },
    onAddKyujitsu() {
      this.form.kyujitsuList.push({
        hizuke: '',
        kyujitsuMei: '',
        kyujitsuFlag: true,
        eigyobiFlag: false
      });
    },
    onAddShainSokai() {
      this.form.shainSokaiList.push({
        hizuke: '',
        kyujitsuMei: '社員総会',
        kyujitsuFlag: false,
        eigyobiFlag: true,
        kijunShigyoJikoku: '',
        kijunShugyoJikoku: '',
        kijunChusyokuJikan: '',
        kijunKyukeiJikan: ''
      });
    },
    onDelete(type, index, hizuke, kyujitsuMei) {
      this.$confirm(`この行を削除します。よろしいですか？<br/>（${hizuke} ${kyujitsuMei}）`, '確認', {
        confirmButtonText: 'はい',
        cancelButtonText: 'キャンセル',
        type: 'info',
        dangerouslyUseHTMLString: true
      }).then(() => {
        if (type == 'kyujitsu' ) {
          this.form.kyujitsuList.splice(index, 1);
        } else {
          this.form.shainSokaiList.splice(index, 1);
        }
      });
    },
  },
}
</script>

<style scoped>
#formArea {
  width: 800px;
  margin-left: auto;
  margin-right: auto;
  line-height: 35px;
}
#detailArea {
  width: 1250px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 10px;
  text-align: left;
  border-top: 1px solid rosybrown;
}
.kuni {
  width: 100px;
}
.nen {
  width: 110px;
  margin-bottom: 10px;
}
.hizuke {
  width: 135px;
}
.jikoku {
  width: 100px;
}
.sakujo {
  padding-left: 5px;
  padding-right: 5px;
  width: 40px;
}
.tsuika {
  margin-top: 10px;
  width: 60px;
}
.kyujitsuToroku >>> .el-dialog__body {
  padding-top: 10px;
}
#detailArea >>> .title {
  font-size: 12pt;
  font-weight: bold;
  color: teal;
}
#detailArea >>> .el-col {
  padding-left: 20px;
}
#detailArea >>> .el-input__inner, #detailArea >>> .el-input__icon {
  font-family: inherit;
  height: 28px;
  line-height: 28px;
}
</style>
